<template>
  <div class="">
    <div class="row">
      <div class="col-12 mb-4">
        <h4><i class="bx bx-file-blank"></i> Detail Information</h4>
        <hr />
        <b-alert show dismissible variant="danger" v-if="submitted && !isValid">
          <span class="d-flex align-items-center">
            <i class="bx bx-x-circle bx-sm mr-2"></i>
            {{ $t("malware.malware-data") }}
          </span>
        </b-alert>
      </div>
      <div class="col-12 mb-5">
        <div class="form-group row mb-3">
          <label class="col-md-2 col-form-label" for="title">
            Notification <br />
            <small>( Information about malware rating )</small>
            <b-form-checkbox
              v-model="form.set_notification"
              switch
              class="mt-4"
            >
              <label>Included in report</label>
            </b-form-checkbox>
            <small>
              If this is enabled then the field beside must be filled
            </small>
            <br />
            <small class="text-danger">
              *Maximum images size : 2480 x 3508
            </small>
            <!-- {{ form.set_notification }} -->
          </label>
          <div
            class="col-md-10"
            :class="theme == 'dark' ? 'tiny-dark-mode' : ''"
          >
            <editor
              api-key="di0d6p4b4nj9k4850qs11584u8qvjfzvtgmkrr5nqvacdm7p"
              :init="options"
              v-model="form.notification"
            ></editor>
            <!-- <tiny-mce id="description" v-model="form.notification"></tiny-mce> -->
            <!-- <vue2-tinymce-editor
              v-model="form.notification"
            ></vue2-tinymce-editor> -->
            <!-- <vue-editor
              ref="ed_notification"
              content-type="html"
            ></vue-editor> -->
          </div>
        </div>
      </div>
      <div class="col-12 mb-4">
        <hr />
      </div>
      <div class="col-12 mb-5">
        <div class="form-group row mb-3">
          <label class="col-md-2 col-form-label" for="title">
            Description Malware <br />
            <small>( Information about malware )</small>
            <b-form-checkbox
              v-model="form.set_description_malware"
              switch
              class="mt-4"
            >
              <label>Included in report</label>
            </b-form-checkbox>
            <small>
              If this is enabled then the field beside must be filled
            </small>

            <br />
            <small class="text-danger">
              *Maximum images size : 2480 x 3508
            </small>
          </label>
          <div
            class="col-md-10"
            :class="theme == 'dark' ? 'tiny-dark-mode' : ''"
          >
            <editor
              api-key="di0d6p4b4nj9k4850qs11584u8qvjfzvtgmkrr5nqvacdm7p"
              :init="options"
              v-model="form.description_malware"
            ></editor>
            <!-- <vue-editor v-model="form.description_malware"></vue-editor> -->
          </div>
        </div>
      </div>
      <div class="col-12 mb-4">
        <hr />
      </div>
      <div class="col-12 mb-5">
        <div class="form-group row mb-3">
          <label class="col-md-2 col-form-label" for="title">
            Static Analysis <br />
            <b-form-checkbox
              v-model="form.set_static_analysis"
              switch
              class="mt-4"
            >
              <label>Included in report</label>
            </b-form-checkbox>
            <small>
              If this is enabled then the field beside must be filled
            </small>

            <br />
            <small class="text-danger">
              *Maximum images size : 2480 x 3508
            </small>
          </label>
          <div
            class="col-md-10"
            :class="theme == 'dark' ? 'tiny-dark-mode' : ''"
          >
            <editor
              api-key="di0d6p4b4nj9k4850qs11584u8qvjfzvtgmkrr5nqvacdm7p"
              :init="options"
              v-model="form.static_analysis"
            ></editor>
            <!-- <vue-editor v-model="form.static_analysis"></vue-editor> -->
          </div>
        </div>
      </div>
      <div class="col-12 mb-4">
        <hr />
      </div>
      <div class="col-12 mb-5">
        <div class="form-group row mb-3">
          <label class="col-md-2 col-form-label" for="title">
            Dynamic Analysis <br />
            <b-form-checkbox
              v-model="form.set_dynamic_analysis"
              switch
              class="mt-4"
            >
              <label>Included in report</label>
            </b-form-checkbox>
            <small>
              If this is enabled then the field beside must be filled
            </small>

            <br />
            <small class="text-danger">
              *Maximum images size : 2480 x 3508
            </small>
          </label>
          <div
            class="col-md-10"
            :class="theme == 'dark' ? 'tiny-dark-mode' : ''"
          >
            <editor
              api-key="di0d6p4b4nj9k4850qs11584u8qvjfzvtgmkrr5nqvacdm7p"
              :init="options"
              v-model="form.dynamic_analysis"
            ></editor>
            <!-- <vue-editor v-model="form.dynamic_analysis"></vue-editor> -->
          </div>
        </div>
      </div>
      <div class="col-12 mb-4">
        <hr />
      </div>
      <div class="col-12 mb-5">
        <div class="form-group row mb-3">
          <label class="col-md-2 col-form-label" for="title">
            Network Analysis <br />
            <b-form-checkbox
              v-model="form.set_network_analysis"
              switch
              class="mt-4"
            >
              <label>Included in report</label>
            </b-form-checkbox>
            <small>
              If this is enabled then the field beside must be filled
            </small>

            <br />
            <small class="text-danger">
              *Maximum images size : 2480 x 3508
            </small>
          </label>
          <div
            class="col-md-10"
            :class="theme == 'dark' ? 'tiny-dark-mode' : ''"
          >
            <editor
              api-key="di0d6p4b4nj9k4850qs11584u8qvjfzvtgmkrr5nqvacdm7p"
              :init="options"
              v-model="form.network_analysis"
            ></editor>
            <!-- <vue-editor v-model="form.network_analysis"></vue-editor> -->
          </div>
        </div>
      </div>
      <div class="col-12 mb-4">
        <hr />
      </div>
      <div class="col-12 mb-5">
        <div class="form-group row mb-3">
          <label class="col-md-2 col-form-label" for="title">
            Additional Information <br />
            <b-form-checkbox
              v-model="form.set_additional_information"
              switch
              class="mt-4"
            >
              <label>Included in report</label>
            </b-form-checkbox>
            <small>
              If this is enabled then the field beside must be filled
            </small>

            <br />
            <small class="text-danger">
              *Maximum images size : 2480 x 3508
            </small>
          </label>
          <div
            class="col-md-10"
            :class="theme == 'dark' ? 'tiny-dark-mode' : ''"
          >
            <editor
              api-key="di0d6p4b4nj9k4850qs11584u8qvjfzvtgmkrr5nqvacdm7p"
              :init="options"
              v-model="form.additional_info"
            ></editor>
            <!-- <vue-editor v-model="form.additional_info"></vue-editor> -->
          </div>
        </div>
      </div>
      <div class="col-12 mb-4">
        <hr />
      </div>
      <div class="col-12 mb-5">
        <div class="form-group row mb-3">
          <label class="col-md-2 col-form-label" for="title">
            Recommendation <br />
            <b-form-checkbox
              v-model="form.set_recommendation"
              switch
              class="mt-4"
            >
              <label>Included in report</label>
            </b-form-checkbox>
            <small>
              If this is enabled then the field beside must be filled
            </small>

            <br />
            <small class="text-danger">
              *Maximum images size : 2480 x 3508
            </small>
          </label>
          <div
            class="col-md-10"
            :class="theme == 'dark' ? 'tiny-dark-mode' : ''"
          >
            <editor
              api-key="di0d6p4b4nj9k4850qs11584u8qvjfzvtgmkrr5nqvacdm7p"
              :init="options"
              v-model="form.recommendation"
            ></editor>
            <!-- <vue-editor v-model="form.recommendation"></vue-editor> -->
          </div>
        </div>
      </div>
      <div class="col-12 mb-4">
        <hr />
      </div>
      <div class="col-12 mb-5">
        <div class="form-group row mb-3">
          <label class="col-md-2 col-form-label" for="title">
            Attachment <br />
            <b-form-checkbox v-model="form.set_attachment" switch class="mt-4">
              <label>Included in report</label>
            </b-form-checkbox>
            <small>
              If this is enabled then the field beside must be filled
            </small>

            <br />
            <small class="text-danger">
              *Maximum images size : 2480 x 3508
            </small>
          </label>
          <div
            class="col-md-10"
            :class="theme == 'dark' ? 'tiny-dark-mode' : ''"
          >
            <editor
              api-key="di0d6p4b4nj9k4850qs11584u8qvjfzvtgmkrr5nqvacdm7p"
              :init="options"
              v-model="form.attachment"
            ></editor>
            <!-- <vue-editor v-model="form.attachment"></vue-editor> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { required, requiredIf } from "vuelidate/lib/validators";
import { TabContent } from "vue-form-wizard";
import ReportService from "@/helpers/report.service";
import moment from "moment";
import { userService } from "@/helpers/authservice/user.service";
import Editor from "@tinymce/tinymce-vue";
// import TinyMce from "tinymce-vue-2";
// import { Vue2TinymceEditor } from "vue2-tinymce-editor";

/**
 * Projects-grid component
 */
export default {
  components: {
    TabContent,
    VueEditor,
    // Vue2TinymceEditor,
    Editor,
  },
  props: {
    validationsProcess: Boolean,
    idReport: { type: String, default: "" },
  },
  data() {
    return {
      form: {
        notification: "",
        description_malware: "",
        static_analysis: "",
        dynamic_analysis: "",
        network_analysis: "",
        additional_info: "",
        recommendation: "",
        attachment: "",
        set_notification: true,
        set_description_malware: true,
        set_static_analysis: true,
        set_dynamic_analysis: true,
        set_network_analysis: true,
        set_additional_information: true,
        set_recommendation: true,
        set_attachment: true,
      },
      theme: localStorage.getItem("theme") ?? "light",
      submitted: false,
      idValid: true,
      options: {
        height: 500,
        skin: localStorage.getItem("theme") == "dark" ? "oxide-dark" : "",
        content_css: localStorage.getItem("theme") == "dark" ? "dark" : "",
        plugins: [
          "advlist autolink lists link image charmap print preview anchor",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste code help wordcount",
        ],
        toolbar:
          "undo redo | fontselect | fontsizeselect | formatselect | bold underline italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat image table | help",
        image_title: true,
        /* enable automatic uploads of images represented by blob or data URIs*/
        automatic_uploads: true,
        file_picker_types: "image",
        file_picker_callback: function (callback, value, meta) {
          var input = document.createElement("input");
          input.setAttribute("type", "file");
          input.setAttribute("accept", "image/*");

          input.onchange = function () {
            var file = this.files[0];

            var reader = new FileReader();
            reader.onload = function () {
              var id = "blobid" + new Date().getTime();
              var blobCache = tinymce.activeEditor.editorUpload.blobCache;
              var base64 = reader.result.split(",")[1];
              var blobInfo = blobCache.create(id, file, base64);
              blobCache.add(blobInfo);

              callback(blobInfo.blobUri(), { title: file.name });
            };
            reader.readAsDataURL(file);
          };

          input.click();
        },
      },
    };
  },
  validations: {},
  computed: {
    edNotif() {
      return this.$refs.ed_notification;
    },
  },
  watch: {
    validationsProcess: {
      immediate: true,
      handler(n) {
        if (n) {
          this.validation();
        }
      },
    },
  },
  methods: {
    detailReport() {
      let ferr = 0;
      const id = this.$route.query.id;
      if (id) {
        ReportService.detail(this.idReport)
          .then((res) => {
            if (res.status == 201) {
              let new_token = res.data.refresh_access_token;
              userService.splitToken(new_token);
              this.detailReport();
              ferr = 1;
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              ferr = 2;
              this.form.notification = res.data.data.details.notification;
              this.form.description_malware = res.data.data.details.description;
              this.form.static_analysis = res.data.data.details.static_analysis;
              this.form.dynamic_analysis =
                res.data.data.details.dynamic_analysis;
              this.form.network_analysis =
                res.data.data.details.network_analysis;
              this.form.additional_info =
                res.data.data.details.additional_information;
              this.form.recommendation = res.data.data.details.recommendation;
              this.form.attachment = res.data.data.details.attachment;
              this.form.set_notification =
                res.data.data.details.set_notification == 1 ? true : false;
              this.form.set_description_malware =
                res.data.data.details.set_description == 1 ? true : false;
              this.form.set_static_analysis =
                res.data.data.details.set_static_analysis == 1 ? true : false;
              this.form.set_dynamic_analysis =
                res.data.data.details.set_dynamic_analysis == 1 ? true : false;
              this.form.set_network_analysis =
                res.data.data.details.set_network_analysis == 1 ? true : false;
              this.form.set_additional_information =
                res.data.data.details.set_additional_information == 1
                  ? true
                  : false;
              this.form.set_recommendation =
                res.data.data.details.set_recommendation == 1 ? true : false;
              this.form.set_attachment =
                res.data.data.details.set_attachment == 1 ? true : false;
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.detailReport();
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log("err ->> ", err);
              }
            }
          });
      }
    },
    validation() {
      this.submitted = true;
      this.isValid = true;
      if (this.form.set_notification && !this.form.notification) {
        this.$emit("validation-failed");
        this.submitted = false;
        setTimeout(() => {
          this.submitted = true;
          this.isValid = false;
        }, 200);
        return;
      }
      if (
        this.form.set_desccription_malware &&
        !this.form.description_malware
      ) {
        this.$emit("validation-failed");
        this.submitted = false;
        setTimeout(() => {
          this.submitted = true;
          this.isValid = false;
        }, 200);
        return;
      }
      if (this.form.set_static_analysis && !this.form.static_analysis) {
        this.$emit("validation-failed");
        this.submitted = false;
        setTimeout(() => {
          this.submitted = true;
          this.isValid = false;
        }, 200);
        return;
      }
      if (this.form.set_dynamic_analysis && !this.form.dynamic_analysis) {
        this.$emit("validation-failed");
        this.submitted = false;
        setTimeout(() => {
          this.submitted = true;
          this.isValid = false;
        }, 200);
        return;
      }
      if (this.form.set_network_analysis && !this.form.network_analysis) {
        this.$emit("validation-failed");
        this.submitted = false;
        setTimeout(() => {
          this.submitted = true;
          this.isValid = false;
        }, 200);
        return;
      }
      if (this.form.set_additional_information && !this.form.additional_info) {
        this.$emit("validation-failed");
        this.submitted = false;
        setTimeout(() => {
          this.submitted = true;
          this.isValid = false;
        }, 200);
        return;
      }
      if (this.form.set_recommendation && !this.form.recommendation) {
        this.$emit("validation-failed");
        this.submitted = false;
        setTimeout(() => {
          this.submitted = true;
          this.isValid = false;
        }, 200);
        return;
      }
      if (this.form.set_attachment && !this.form.attachment) {
        this.$emit("validation-failed");
        this.submitted = false;
        setTimeout(() => {
          this.submitted = true;
          this.isValid = false;
        }, 200);
        return;
      }
      this.updateReport();
    },
    updateReport() {
      let ferr = 0;
      ReportService.update(this.idReport, this.form)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.updateReport();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.$emit("id-report", response.data.data.id_report);
            this.$emit("next-tab");
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.updateReport();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
          }
        });
    },
  },
  mounted() {
    this.detailReport();
  },
};
</script>
<style>
.btn-active {
  background-color: #024284;
}
/* .tiny-dark-mode .tox .tox-dialog {
  background-color: #022b3a;
} */
.tiny-dark-mode .tox .tox-menubar {
  background-color: #022b3a;
}
.tiny-dark-mode .tox .tox-statusbar {
  background-color: #022b3a;
}
.tiny-dark-mode .tox .tox-toolbar-overlord {
  background-color: #022b3a !important;
}
.tiny-dark-mode .tox .tox-toolbar-overlord .tox-toolbar__primary {
  background-color: #022b3a !important;
}
.tiny-dark-mode .tox iframe {
  /* filter: invert(37%) sepia(22%) saturate(3928%) hue-rotate(166deg)
    brightness(101%) contrast(95%); */
  filter: opacity(70%);
  color: #fff;
}
.tox-notifications-container {
  position: absolute;
  left: -1120px !important;
  bottom: 0px !important;
  max-height: 947px;
}
</style>
